<template>
  <vs-table hover-flat v-if="slogans && slogans.length" :data="slogans" class="table-slogans-list">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('slogan')"></vs-th>
      <vs-th class="text-center" v-text="$t('status')"></vs-th>
      <vs-th v-text="$t('reception_division_code')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count"></vs-td>
        <vs-td>
          <vs-input :placeholder="$t('slogan')" v-model="tr.name" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.sloganFormErrors.name"></validation-error>
          <span v-if="tr.edit == false">{{ tr.name }}</span>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-switch v-model="tr.is_active" @click.prevent="$emit('customClickStatus', indextr, tr.id)">
              <span slot="on">{{ $t('active') }}</span>
              <span slot="off">{{ $t('inactive') }}</span>
            </vs-switch>
          </div>
        </vs-td>
        <vs-td v-text="tr.id"></vs-td>
        <vs-td>
          <div class="flex justify-center">
            <template v-if="tr.edit == true">
              <save-button @click="$emit('customClickSave', indextr, tr.id)" :id="'updateSloganButton' + tr.id"></save-button>&nbsp;
              <cancel-button @click="$emit('customClickCancel', indextr, tr.id)"></cancel-button>
            </template>
            <template v-if="tr.edit == false">
              <edit-button @click="$emit('customClickEdit', indextr, tr.id)"></edit-button>&nbsp;
              <delete-button @click="$emit('customClickDelete', indextr, tr.id)"></delete-button>
            </template>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Slogans.List',
  props: {
    slogans: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
.table-slogans-list {
  tr {
    th {
      &:nth-child(1) { width: 5%; }
      &:nth-child(2) { width: 50%; }
      &:nth-child(3) { width: 10%; }
      &:nth-child(4) { width: 20%; }
      &:nth-child(5) { width: 15%; }
    }

    th,
    td {
      vertical-align: middle;
    }
  }
}
</style>
